import {useEffect, useRef, useState} from "react"
import {Grid, GridCellProps, GridColumn, GridDataStateChangeEvent, GridToolbar} from "@progress/kendo-react-grid"
import {useAppSelector} from "../../../store"
import {RootState} from "../../../rootReducer"
import {SpinnerGrid} from "../../../shared/CommonItems"
import {Tooltip} from "@progress/kendo-react-tooltip"
import {process, State} from "@progress/kendo-data-query"
import {useInternationalization} from "@progress/kendo-react-intl"
import {columnProps} from "../../../shared/ActiveGridFilter"
import {ExcelExport} from "@progress/kendo-react-excel-export"
import {processExportData} from "../../../utils/common"
import {Button} from "@progress/kendo-react-buttons"
import {TestCosts} from "../../../containers/DvsaTest/dvsatestsSlice"

const DvsaTestsChargesGrid = () => {
    const initialState: State = {skip: 0, take: 50}

    const intl = useInternationalization()

    const testCostData = useAppSelector((state: RootState) => state.containers.dvsaTest.testCostsData)
    const dvsatestChargesLoding = useAppSelector((state: RootState) => state.containers.dvsaTest.testCostsLoading)

    const _export = useRef<ExcelExport | null>(null)
    const [dataState, setDataState] = useState(initialState)

    useEffect(() => {
        setDataState(initialState)
    }, [testCostData])

    const CustomColumnCell = (props: GridCellProps) => (
        <td title={props.dataItem[`${props.field}`]}>{props.dataItem[`${props.field}`]}</td>
    )

    const currencyFormatExcel = (value: any) => {
        const currencyVal = value == null || value === "" ? "" : intl.formatNumber(value, "c")
        return currencyVal
    }

    const exportExcelData = (testCostData: TestCosts[]) =>
        testCostData!.map(({charges, ...item}) => ({
            charges: currencyFormatExcel(charges),
            ...item,
        }))

    return (
        <div className="position-relative">
            {dvsatestChargesLoding && <SpinnerGrid />}
            <Tooltip openDelay={100} position="bottom" anchorElement="target">
                <ExcelExport
                    fileName={crypto.randomUUID()}
                    data={exportExcelData(processExportData(testCostData, dataState))}
                    ref={_export}
                >
                    <Grid
                        style={{
                            height: "calc(100vh - 13rem)",
                        }}
                        data={process(testCostData, dataState)}
                        {...dataState}
                        sortable={true}
                        pageable={true}
                        onDataStateChange={(e: GridDataStateChangeEvent) => setDataState(e.dataState)}
                    >
                        <GridToolbar>
                            <Button
                                fillMode="flat"
                                themeColor={"primary"}
                                className="buttons-container-button"
                                iconClass="fa fa-file-excel"
                                onClick={() => _export.current !== null && _export.current.save()}
                                disabled={process(testCostData, dataState).total === 0}
                            >
                                Export to Excel
                            </Button>
                        </GridToolbar>
                        <GridColumn {...columnProps("code", dataState)} field="code" title="Code" width="190px" />
                        <GridColumn
                            {...columnProps("test", dataState)}
                            field="test"
                            title="Test"
                            cell={CustomColumnCell}
                            width="190px"
                        />
                        <GridColumn
                            {...columnProps("testType", dataState)}
                            field="testType"
                            title="Test Type"
                            cell={CustomColumnCell}
                            width="250px"
                        />
                        <GridColumn {...columnProps("axle", dataState)} width={"130px"} field="axle" title="Axle" />
                        <GridColumn
                            {...columnProps("duration", dataState)}
                            width={"130px"}
                            field="duration"
                            title="Duration"
                            cell={(props: any) => <td className="text-end pe-5">{props.dataItem[`${props.field}`]}</td>}
                        />
                        <GridColumn
                            {...columnProps("charges", dataState)}
                            width={"130px"}
                            field="charges"
                            title="Test Fee"
                            format="{0:0}"
                            cell={(props: any) => (
                                <td className="text-end pe-5">
                                    {intl.formatNumber(props.dataItem.charges, {
                                        style: "currency",
                                        minimumFractionDigits: 2,
                                    })}
                                </td>
                            )}
                        />
                    </Grid>
                </ExcelExport>
            </Tooltip>
        </div>
    )
}

export default DvsaTestsChargesGrid
